export const ru = {
    no: 'Нет',
    yes: 'Да'
};
